import { HIDE_CONFIRM_DIALOG } from 'src/vuex/modules/confirm-dialog/types'
import { NOTIFY_ERROR, NOTIFY_SUCCESS } from 'src/vuex/modules/snackbar/types'
import {
  approveEtp,
  cancelEtp,
  getPayableDetails,
  getPayables
} from '../apiCalls'
import * as types from './types'

export default {
  [types.GET_PAYABLES]: async ({ commit, getters, dispatch }) => {
    commit(types.SET_IS_LOADING, true)

    try {
      const params = getters[types.PARAMS_TO_SEND]

      const payables = await getPayables(params)

      commit(types.SET_PAYABLES, payables.results)
      commit(types.SET_TOTAL_ITEMS, payables.pagination.total_items)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data })

      commit(types.SET_PAYABLES, [])
      commit(types.SET_TOTAL_ITEMS, 0)
    } finally {
      commit(types.SET_IS_LOADING, false)
    }
  },
  [types.CHANGE_PAGINATION]({ commit }, newPagination) {
    commit(types.SET_PAGINATION, newPagination)
  },
  [types.CHANGE_FILTERS]({ commit }, { key, value }) {
    commit(types.SET_FILTERS, {
      key,
      value
    })
  },
  [types.RESET_PAGINATION]({ state, dispatch }) {
    dispatch(types.CHANGE_PAGINATION, {
      ...state.pagination,
      page: 1
    })
  },
  [types.GET_PAYABLE_DETAILS]: async ({ commit, dispatch }, id) => {
    commit(types.SET_IS_LOADING, true)

    try {
      const details = await getPayableDetails(id)

      commit(types.SET_PAYABLE_DETAILS, details)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data })

      commit(types.SET_PAYABLE_DETAILS, {})
    } finally {
      commit(types.SET_IS_LOADING, false)
    }
  },
  [types.OPEN_INVOICE]: ({ commit, dispatch }, info) => {
    commit(types.SET_IS_LOADING, true)

    try {
      commit(types.SET_INVOICE_INFO, info)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, {
        message: `There was an error processing the invoice PDF for the #${info.number} instalment. Contact with Operational Support if you need help.`,
        icon: 'report'
      })
      commit(types.SET_INVOICE_INFO, {
        value: false,
        number: '',
        url: null
      })
    } finally {
      commit(types.SET_IS_LOADING, false)
    }
  },
  [types.APPROVE_PAYABLE_REQUEST]: async ({ commit, dispatch }, { id }) => {
    commit(types.SET_IS_LOADING, true)

    try {
      await approveEtp(id)
      dispatch(types.GET_PAYABLE_DETAILS, id)
      commit(HIDE_CONFIRM_DIALOG, null, { root: true })
      dispatch(NOTIFY_SUCCESS, { message: 'Request successfully approved' })
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data.message })
    } finally {
      commit(types.SET_IS_LOADING, false)
    }
  },
  [types.CANCEL_PAYABLE_REQUEST]: async (
    { commit, dispatch },
    { id, reason }
  ) => {
    commit(types.SET_IS_LOADING, true)

    try {
      await cancelEtp(id, reason)
      dispatch(types.GET_PAYABLE_DETAILS, id)
      dispatch(NOTIFY_SUCCESS, { message: 'Request successfully cancelled' })
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data.message })
    } finally {
      commit(types.SET_IS_LOADING, false)
    }
  }
}
